module.exports = __webpack_public_path__ + "media/images/players/LAHIRI_ANIRBAN-798af5d05e1b13c8414ed7202d5c8d93.png";